import React, { Component } from 'react';
import Authentification from './screens/Authentification';
import AffichageRapport from './screens/AffichageRapport';
import Navbar from './components/layout/Navbar';
import Validation from './screens/Validation';
import MenuRapport from './screens/MenuRapport';
import { Switch, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { aucunDroit, isAuthentified } from './store/actions/authActions';

import { auth, db } from './config/fbConfig';
import { signInAnonymously } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';

class App extends Component {
  state = {
    droit: ''
  };

  async componentDidMount() {
    try {
      await signInAnonymously(auth);
    } catch (error) {
      console.error(error);
    }

    if (!window.localStorage.UUID) {
      this.props.history.push('/authentification');
      return;
    }

    await this.getDroit();
    await this.verifUtilisateur();
  }

  getDroit = async () => {
    if (!window.localStorage.email) {
      this.props.history.push('/authentification');
      return;
    }

    const q = query(
      collection(db, 'autorisations'),
      where('utilisateur', '==', window.localStorage.email)
    );

    const snapshot = await getDocs(q);
    snapshot.forEach(doc => {
      this.setState({ droit: doc.data().autorisation });
    });
  };

  verifUtilisateur = async () => {
    const q = query(
      collection(db, 'utilisateurs'),
      where('UUID', '==', window.localStorage.UUID)
    );

    const snapshot = await getDocs(q);

    if (snapshot.empty) {
      this.props.history.push('/authentification');
      return;
    }

    const droitValide = ['National', 'Secteur', 'Agence'].includes(this.state.droit);

    if (!droitValide) {
      this.props.aucunDroit();
      this.props.history.push('/authentification');
      return;
    }

    if (window.localStorage.getItem('validationStatus') !== 'true') {
      this.props.history.push('/authentification');
      return;
    }

    this.props.isAuthentified(true);
    this.props.history.push('/menu-rapport');
  };

  render() {
    return (
      <div className="App">
        <Navbar />
        <Switch>
          <Route path="/authentification" component={Authentification} />
          <Route path="/rapport" component={AffichageRapport} />
          <Route path="/validation" component={Validation} />
          <Route path="/menu-rapport" component={MenuRapport} />
        </Switch>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  aucunDroit: () => dispatch(aucunDroit()),
  isAuthentified: (auth) => dispatch(isAuthentified(auth))
});

export default withRouter(
  compose(
    connect(null, mapDispatchToProps)
  )(App)
);
